module.exports = __webpack_public_path__ + "static/fonts/FiraSans-Bold.464da42.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-Bold.ttf
// module id = 1162
// module chunks = 5